function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1",
  d: "M.001.004h5.115l2.891 9.7h.045l2.935-9.7h4.981v15.785h-3.291V4.625h-.045L9.474 15.789H6.45L3.336 4.625h-.045v11.164H.001V.004",
  fill: "#004c9b"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 2"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 1",
  fill: "#004c9b",
  d: "M44.462 0h3.291v3.113h-3.291z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 2",
  fill: "#004c9b",
  d: "M44.462 4.225h3.291v11.564h-3.291z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 4"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 3",
  fill: "#004c9b",
  d: "M49.577 0h3.291v15.789h-3.291z"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2",
  d: "M23.299 12.812a2.806 2.806 0 10-2.806-2.806 2.806 2.806 0 002.806 2.806m-6.115-2.81a6.122 6.122 0 116.121 6.122 6.122 6.122 0 01-6.12-6.117z",
  fill: "#d90017"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Component 1 \\u2013 1"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3",
  d: "M36.941 12.817a2.806 2.806 0 10-2.807-2.806 2.806 2.806 0 002.807 2.806m-6.134 2.972V.004h3.288v5.115a4.7 4.7 0 013.157-1.157 6.053 6.053 0 010 12.1 4.007 4.007 0 01-3.157-1.29v1.023z",
  fill: "#004c9b"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 9"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 7"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 4",
  d: "M54.96 1.579h-.329v-1.3h-.478V.004h1.284v.279h-.478z",
  fill: "#004c9b"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 8"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 5",
  d: "M57.149 1.579h-.309V.26l-.294 1.319h-.33L55.928.26v1.319h-.312V.004h.482l.286 1.245.282-1.245h.478z",
  fill: "#004c9b"
})));

function SvgMobilLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 10",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57.149 16.129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilLogo);
export default __webpack_public_path__ + "static/media/mobil_logo.df3d0e42.svg";
export { ForwardRef as ReactComponent };